import { array, number, object, ref, string } from "yup";

export default ({ hasAdminPrivileges, intl, isNewForm, partnerRoleSelected }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const passwordMatchText = intl.formatMessage({ id: "app.form.passwordMatch" });
  const validEmailText = intl.formatMessage({ id: "app.form.validEmail" });

  return object().shape({
    ...(isNewForm && { username: string().required(requiredText) }),
    password: string(),
    confirmPassword: string().oneOf([ref("password"), null], passwordMatchText),
    email: string()
      .email(validEmailText)
      .required(requiredText),
    name: string().required(requiredText),
    telephone: number().required(requiredText),
    roleIds: array()
      .of(string().required(requiredText))
      .required(requiredText)
      .min(1, requiredText),
    ...(hasAdminPrivileges
      ? {}
      : {
          serviceContractsFilter: array().of(string().required(requiredText)),
          customerIds: array()
            .of(string().required(requiredText))
            .required(requiredText)
            .min(1, requiredText),
        }),
    partnerId: partnerRoleSelected
      ? string()
          .required(requiredText)
          .nullable()
      : string().nullable(),
    ownedByPartnerId: string().nullable(),
  });
};
